if (location.pathname.includes("collection")) {
    document.addEventListener("DOMContentLoaded", () => {
        if (!location.search.includes("filter.v.availability")) {
            const checkbox = document.getElementById("filter.v.availability-1");
            if (checkbox && checkbox.getAttribute("checked") != true) {
                checkbox.click();
            }
        }
    });
}